import React from 'react';
import { connect } from 'react-redux';

import ConfirmationModal from 'shared/ui/modals/ConfirmationModal';
import { user_Reset } from 'core/redux/user/actions';

const deleteConfirmationModal = ({ user, user_Reset, onCloseModal, selectedAccount, selectedStack }) => {
  return (
    <>
      <ConfirmationModal
        width={500}
        onCloseModal={onCloseModal}
        onSuccess={onCloseModal}
        onFailure={onCloseModal}
        cancelHandler={onCloseModal}
        handleRequestClose={onCloseModal}
        submitHandler={async () => {
          return await user_Reset({
            awsAccount: selectedAccount.value.toLowerCase(),
            user: user,
            stack: selectedStack,
          });
        }}
        bodyText={`Do you really want to delete this order: ${user?.Username ? user?.Username : '- '}? `}
        title={'Delete Order'}
        svgFileName={'users'}
        iconDimensions={{ height: 20, width: 22 }}
        alt="User"
        confirmText="Delete"
        cancelText="Cancel"
      />
    </>
  );
};

export default connect(
  (state) => ({
    isFetchingUsers: state.user.isFetchingUsers,
  }),
  (dispatch) => ({
    user_Reset: (userDetails) => dispatch(user_Reset(userDetails)),
  })
)(deleteConfirmationModal);
